<template>
  <div>
     <!-- <el-carousel :interval="5000" arrow="always" height="600px" > -->
       <!-- <el-carousel-item > -->
          <img src="@/assets/images/newfolder/5.png" alt="公司首页 banner"  style=" width: 1715px;height: 400px;"/>
        <!-- </el-carousel-item> -->
      <!-- </el-carousel> -->
  <div class="career-section">
    <h1>联系我们</h1>
     <img src="../assets/images/newfolder/4.png"/> 
  <div class="mt20">
  <div class="contact-info">总部电话：010-63967431</div>
  <div class="contact-info">家政电话：15699771333</div>
  <div class="contact-info">广招合伙人：15699771333</div>
  </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Career'
};
</script>

<style scoped>
.mt20 {
  margin-top: 20px;
}
.career-section {
  margin-top: 40px;
  padding: 20px;
  background-color: #f8f9fa;
}

.contact-info {
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>